import React, { useEffect } from 'react';
import type { Provider } from '../../common/services/cache-provider/types.tsx';
import type { SeriesDataEntity } from '../../common/summary/types.tsx';
import { DrillDownReportExperience } from '../../experiences.tsx';
import Error from './error/index.tsx';
import IssueTable from './issue-table/index.tsx';
import { PaginationLabel } from './pagination-count-label/index.tsx';
import { SeriesPicker } from './series-picker/index.tsx';
import { SummaryTable } from './summary-table/index.tsx';

type Props = {
	isDisabled?: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	summaryResource: Provider<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	drilldownResource: Provider<any>;
	selectedDrillDownPoint: SeriesDataEntity | undefined;
	onSetDrillDownPoint: (arg1: SeriesDataEntity | undefined) => void;
	onDrilldownPageChange: (arg1: number) => void;
};

const Table = ({
	summaryResource,
	drilldownResource,
	isDisabled,
	selectedDrillDownPoint,
	onSetDrillDownPoint,
	onDrilldownPageChange,
}: Props) => {
	useEffect(() => {
		if (!drilldownResource.loading && drilldownResource.data) {
			DrillDownReportExperience.success();
		}
	}, [drilldownResource.loading, drilldownResource.data]);

	if (
		summaryResource.error !== undefined ||
		drilldownResource.error !== undefined ||
		summaryResource.data === undefined
	) {
		if (drilldownResource.error !== undefined) {
			DrillDownReportExperience.failure();
		}
		return <Error />;
	}

	if (!selectedDrillDownPoint) {
		return (
			<SummaryTable
				isDisabled={isDisabled}
				source={summaryResource.data}
				onSelect={({ data }) => {
					onSetDrillDownPoint(data);
				}}
			/>
		);
	}

	const { data, loading } = drilldownResource;

	return (
		<>
			<SeriesPicker
				source={summaryResource.data}
				selectedDrillDownPoint={selectedDrillDownPoint}
				onSwitchSeries={onSetDrillDownPoint}
				// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
				onSwitchTable={() => onSetDrillDownPoint()}
			/>
			<IssueTable onPageChange={onDrilldownPageChange} {...data} loading={loading} />
			{data && <PaginationLabel label={data.paginationCountString} />}
		</>
	);
};

export default Table;
